







exports.default =
  props: ['total', 'value', 'label', 'show_details', 'show_raw_value']

  computed:
    value_text: ->
      if @total && @total != 0
        if @show_details
          "#{@value}/#{@total}"
        else
          ((parseFloat(@value) / @total) * 100.0).toFixed(1).replace('.', ',') + '%'
      else
        if @show_raw_value && @value
          @value
        else
          '--'



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/statistic_table_col.vue